import { cardPeriodForDate } from "./finance";
import type { CardConfig, PendingItem } from "./types";

export type PendingCutFilter = "all" | "previous" | "current";
type CutConfig = Pick<CardConfig, "paymentMethod" | "cutDay">;

/** The calendar cut is independent of fortnight boundaries and pending balances. */
export function pendingCutPeriods(today: string, cutDay: number): { current?: string; previous?: string } {
  const current = cardPeriodForDate(today, cutDay);
  if (!current) return {};
  const beforeStart = new Date(`${current.slice(0, 10)}T12:00:00Z`);
  beforeStart.setUTCDate(beforeStart.getUTCDate() - 1);
  return { current, previous: cardPeriodForDate(beforeStart.toISOString().slice(0, 10), cutDay) };
}

/** Stored cuts take priority; only absent cuts are inferred, using the installment date when present. */
export function pendingItemPeriod(item: PendingItem, cards: CutConfig[]): string | undefined {
  if (item.period.trim()) return item.period.trim();
  const card = cards.find(candidate => candidate.paymentMethod === item.card);
  if (!card) return undefined;
  return cardPeriodForDate(item.installmentDueOn ?? item.date, card.cutDay);
}

export function filterPendingByCut(items: PendingItem[], cards: CutConfig[], today: string, cut: PendingCutFilter): PendingItem[] {
  if (cut === "all") return items;
  const periods = new Map(cards.map(card => [card.paymentMethod, pendingCutPeriods(today, card.cutDay)[cut]]));
  return items.filter(item => {
    const period = periods.get(item.card);
    return Boolean(period && pendingItemPeriod(item, cards) === period);
  });
}

export function pendingVisibleTotals(items: PendingItem[]): { ownCents: number; reimbursementCents: number } {
  return items.reduce((sum, item) => ({ ownCents: sum.ownCents + item.ownPendingCents, reimbursementCents: sum.reimbursementCents + item.reimbursementPendingCents }), { ownCents: 0, reimbursementCents: 0 });
}
